import { useEffect, useRef } from "react";

/**
 * Play video when intersection is happening.
 *
 * @param options
 * @returns {React.MutableRefObject<null>[]}
 */
function useVideoAutoplayOnIntersect(options) {
  const containerRef = useRef(null);
  const videoRef = useRef(null);

  const cb = (entries) => {
    const [entry] = entries;
    if (
      entry.isIntersecting &&
      !videoRef.current.ended &&
      videoRef.current.paused
    ) {
      videoRef.current.play();
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(cb, options);

    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, [containerRef, options]);

  return [containerRef, videoRef];
}

export default useVideoAutoplayOnIntersect;
